import React from "react";
import ButtonLoading from "../Button/ButtonLoading";
import ModalBasic from "../ModalBasic";

export default function ModalDelete({
  title,
  showDeleteConfirmationModal,
  setShowDeleteConfirmationModal,
  DeleteFunction,
  buttonLoading,
}) {
  return (
    <ModalBasic
      id="delete-modal"
      modalOpen={showDeleteConfirmationModal}
      setModalOpen={setShowDeleteConfirmationModal}
    >
      <div className="p-5 flex space-x-4">
        {/* Icon */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0 bg-rose-100">
          <svg
            className="w-4 h-4 shrink-0 fill-current text-rose-500"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
          </svg>
        </div>
        {/* Content */}
        <div className="w-full">
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-lg font-semibold text-slate-800">
              Delete this {title}?
            </div>
          </div>
          {/* Modal content */}
          <div className="text-sm mb-10">
            <div className="space-y-2">
              <p>
                {title} will be removed from your list of {title}.
              </p>
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirmationModal(false);
              }}
            >
              Cancel
            </button>
            <ButtonLoading
              buttonName="Yes, Delete"
              backgroundColor="rose"
              onClickFunction={(e) => {
                e.stopPropagation();
                DeleteFunction();
              }}
              isLoading={buttonLoading}
            />
          </div>
        </div>
      </div>
    </ModalBasic>
  );
}
